/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item) => {
        item.addEventListener('click', () => {
          const panelId = item.dataset.id;
          const tabButtons = this.buttons.querySelectorAll('button');
          const tabIndex = Array.from(tabButtons).findIndex((btn) => btn.dataset.panelId === panelId);
          if (tabIndex < 0) {
            return;
          }
          this.buttons.toggleActiveClass(tabIndex);
          OverlayManager.open(this.drawer);
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}